<template>
  <div class="app-container">
    <!-- Modal para la seleccion de empresa -->
    <Modal id="modalSelecEmpresa" :modalShow="modalShow" size="600">
      <template slot="title">
        <v-container fluid text-xs-center>
          <v-layout align-center justify-center>
            <v-flex xs4>
              <img src="@/resources/img/cnmc-logo.png" class="logo" />
            </v-flex>
            <v-flex xs8>
              <span class="titulo">{{ $t('message.login.titulo') }}</span>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
      <v-container fluid text-xs-center>
        <div v-if="!sinEmpresas && !wrongCertificate">
          <SeleccionEmpresa @changed="changeHandler" :empresas="empresas"> </SeleccionEmpresa>
        </div>

        <!-- Error: Usuario sin empresas asociadas -->
        <MessageBox
          id="boxSinEmpresas"
          title="Acceso restringido"
          type="warning"
          v-if="sinEmpresas"
        >
          <p>{{ $t('message.login.sinEmpresa') }}.</p>
        </MessageBox>

        <!-- Error: Certificado no válido -->
        <MessageBox
          id="boxWrongCertificate"
          title="Acceso restringido"
          type="error"
          v-if="wrongCertificate"
          ><div class="w-100" v-html="$t('message.login.sinAcceso')"></div>
        </MessageBox>
      </v-container>
    </Modal>
  </div>
</template>

<script>
import { SeleccionEmpresa, MessageBox, Modal } from '@/components';
import logger from '@/utils/logger';
import { mapGetters, mapActions } from 'vuex';

let redirectTo = '/';
export default {
  mounted() {
    this.login();
  },
  data() {
    return {
      sinEmpresas: false,
      wrongCertificate: false,
      fullPage: false,
      modalShow: false
    };
  },
  components: {
    SeleccionEmpresa,
    MessageBox,
    Modal
  },
  computed: {
    ...mapGetters(['empresas'])
  },
  methods: {
    ...mapActions(['setLoading', 'setEmpresaSelected', 'loadMaestras', 'login']),
    login() {
      this.setLoading(true);
      this.$store
        .dispatch('login')
        .then(() => {
          if (this.empresas.length == 0) {
            this.sinEmpresas = true;
            return;
          }
          // Preparamos el redirect
          redirectTo = '/';
          if (this.$route.params.redirect) {
            redirectTo = JSON.parse(atob(this.$route.params.redirect));
          }
          //Cargamos los catalogos
          this.loadMaestras();
        })
        .catch(error => {
          this.wrongCertificate = true;
          logger.print(error);
        })
        .then(() => {
          this.setLoading(false);
          if (
            this.$route.params.redirect &&
            JSON.parse(atob(this.$route.params.redirect)).path === '/tasas/info-pago'
          ) {
            let redirectLocal = JSON.parse(atob(this.$route.params.redirect));
            let emp = this.empresas.filter(
              item => item.idempres === parseInt(atob(redirectLocal.params.empresa).split(';')[0])
            )[0];
            this.modalShow = false;
            this.setEmpresaSelected(emp);
            this.$router.push({ name: 'infopago', params: { NRC: redirectLocal.params.NRC } });
          } else if (this.empresas && this.empresas.length === 1) {
            this.changeHandler(this.empresas[0]);
          } else {
            this.modalShow = true;
          }
        });
    },
    changeHandler(empresa) {
      this.modalShow = false;
      this.setEmpresaSelected(empresa);
      this.goToRedirect();
    },
    goToRedirect() {
      this.$router.push(redirectTo);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/resources/styles/variables.scss';
.logo {
  width: 180px;
  height: 40px;
}

span.titulo {
  color: $color-text-secondary;
  font-size: 25px;
}

.container {
  padding: 5px;
}

.w-100 {
  width: 100%;
}
</style>
